module.exports = __webpack_public_path__ + "02_hair_black.448065f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/02_hair_black.png
// module id = u6d6
// module chunks = 0